import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetCustomerReturnInvoicesApi,
  GetAllCustomerReturnsApi,
} from "../../ApiRequests";

export const fetchCustomerReturnInvoice = createAsyncThunk(
  "fetch/CustomerReturnInvoice",
  async (arg) => {
    try {
      let response;
      if (typeof arg === "string" && arg) {
        response = await GetCustomerReturnInvoicesApi(arg);
      } else {
        const params = typeof arg === "object" && arg ? arg : undefined;
        response = await GetAllCustomerReturnsApi(params);
      }
      return response?.data?.data.payload;
    } catch (error) {
      console.log(error);
    }
    return [];
  }
);

const CustomerReturnInvoiceSlice = createSlice({
  name: "CustomerReturnInvoice",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCustomerReturnInvoice.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchCustomerReturnInvoice.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.isError = false;
    });
    builder.addCase(fetchCustomerReturnInvoice.rejected, (state) => {
      state.loading = false;
      state.isError = true;
    });
  },
});

export default CustomerReturnInvoiceSlice.reducer;
